import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import enUS from "antd/locale/en_US";
import deDE from "antd/locale/de_DE";
import trTR from "antd/locale/tr_TR";
import arEG from "antd/locale/ar_EG";
import "dayjs/locale/de";
import "dayjs/locale/tr";
import "dayjs/locale/ar";
import dayjs from "dayjs";
import { applyDocumentDirection, isRtlLanguage } from "../i18n.jsx";
import { getAntdTheme } from "../design-system/theme";
import { useIsMobile } from "../design-system/useMediaQuery";

const ANTD_LOCALES = { en: enUS, de: deDE, tr: trTR, ar: arEG };
const DAYJS_LOCALES = { en: "en", de: "de", tr: "tr", ar: "ar" };

/**
 * Keeps Ant Design, dayjs and the document direction in sync with the active
 * i18next language so Arabic renders right-to-left across the whole panel.
 */
const LocaleProvider = ({ theme, children }) => {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  // useTranslation re-renders this subtree on languageChanged, so `code` is
  // always the active language by the time ConfigProvider is rebuilt.
  const code = String(i18n.language || "en").split("-")[0];

  useEffect(() => {
    applyDocumentDirection(code);
    dayjs.locale(DAYJS_LOCALES[code] || "en");
  }, [code]);

  return (
    <ConfigProvider
      theme={theme ?? getAntdTheme(isMobile)}
      locale={ANTD_LOCALES[code] || enUS}
      direction={isRtlLanguage(code) ? "rtl" : "ltr"}
    >
      {children}
    </ConfigProvider>
  );
};

export default LocaleProvider;
